import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { BoardSidebar } from './BoardSidebar';

export const BoardDetailLayout = ({ children }: { children: ReactNode }) => {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="relative">
      <div className="md:pr-6">{children}</div>
      {id && (
        <div className="">
          <BoardSidebar boardId={id} />
        </div>
      )}
    </div>
  );
};
